<template>
    <Phonelist></Phonelist>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Phonelist = defineAsyncComponent(() =>
    import("../../components/ITDepartment/Phonelist.vue")
);

export default {
    name: "IT_Phonelist",
    components: { Phonelist, AuthLayout },
};
</script>
